import React, { useCallback } from 'react';

import { BoardButton } from './BoardButton';
import { forTemplate } from '@trello/i18n';
import { StarredIcons } from 'app/src/components/BoardTile/StarredIcons';

const format = forTemplate('board_list_item');

interface StarredBoardButtonProps {
  readonly idBoard: string;
  readonly isStarred: boolean;
  toggleBoardStar: (idBoard: string) => void;
}

export const StarredBoardButton = ({
  idBoard,
  isStarred,
  toggleBoardStar,
}: StarredBoardButtonProps) => {
  const onClickHandler: React.MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      // The boards menu container registers document-level click handlers, so we
      // need to mute the native event too to make sure this doesn't bubble there.
      e.nativeEvent.stopImmediatePropagation();
      toggleBoardStar(idBoard);
    },
    [toggleBoardStar, idBoard],
  );

  const onKeyDownHandler: React.KeyboardEventHandler = useCallback(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        toggleBoardStar(idBoard);
      }
    },
    [toggleBoardStar, idBoard],
  );

  return (
    <BoardButton
      icon={<StarredIcons isStarred={isStarred} />}
      onClick={onClickHandler}
      onKeyDown={onKeyDownHandler}
      tabIndex={0} // for a11y
      title={format(
        isStarred
          ? 'click-to-unstar-this-board-it-will-be-removed-from-your-starred-list'
          : 'click-to-star-this-board-it-will-be-added-to-your-starred-list',
      )}
    />
  );
};
